import { render, staticRenderFns } from "./SideBarServices.vue?vue&type=template&id=5ec40dc2&scoped=true&"
import script from "./SideBarServices.vue?vue&type=script&lang=js&"
export * from "./SideBarServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec40dc2",
  null
  
)

export default component.exports